import moment from "moment";
import { Order } from "../constants";
import { convertTimestamp } from "./misc";

const escapeCsvValue = (value: unknown): string => {
  const stringValue = value === null || value === undefined ? "" : String(value);
  if (/[",\n]/.test(stringValue)) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
};

const COLUMNS = [
  "Patient Name",
  "Date of Birth",
  "Phone",
  "Email",
  "Rx Number",
  "Medications",
  "Status",
  "Status Date",
  "Order Date",
  "Exported Date",
];

const orderToRow = (order: Order, exportedDate: string): string[] => {
  const patient = order.patient_details;
  const medications = (order.medications || [])
    .map((med) => `${med.itemName} (qty ${med.quantity})`)
    .join("; ");

  return [
    patient ? `${patient.firstName} ${patient.lastName}` : "",
    patient?.dateOfBirth ? moment.utc(patient.dateOfBirth).format("MM/DD/YYYY") : "",
    patient?.phone || "",
    patient?.email || "",
    order.rxNumber || "",
    medications,
    order.currentStatus?.status || "",
    order.currentStatus?.date
      ? moment(convertTimestamp(order.currentStatus.date as any)).format("MM/DD/YYYY")
      : "",
    order.orderDate
      ? moment(convertTimestamp(order.orderDate as any)).format("MM/DD/YYYY")
      : "",
    exportedDate,
  ];
};

export const exportOrdersToSpreadsheet = (orders: Order[], fileName: string) => {
  const exportedDate = moment().format("MM/DD/YYYY");
  const rows = [COLUMNS, ...orders.map((order) => orderToRow(order, exportedDate))];
  const csvContent = rows
    .map((row) => row.map(escapeCsvValue).join(","))
    .join("\r\n");

  const blob = new Blob([`﻿${csvContent}`], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${fileName}_${moment().format("YYYY-MM-DD")}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
